module.exports = __webpack_public_path__ + "static/media/om.397d3f2b.svg";